import type { Signal } from '@preact/signals-react';
import { cloneDeep } from 'lodash';
import type { ContinuousScrollerFilter } from '../../continuous-scroller/continuous-scroller-types';

export class Filters {
  constructor(private filters: Signal<Array<ContinuousScrollerFilter>>) {}

  getFilters() {
    return this.filters.value;
  }

  addFilter(filter: ContinuousScrollerFilter) {
    if (this.filters.value.length > 0) {
      const filterIndex = this.filters.value.findIndex((item) => item.scrollerId === filter.scrollerId);
      const clonedFilters = cloneDeep(this.filters.value);

      if (filterIndex > -1) {
        clonedFilters.splice(filterIndex, 1, filter);
      } else {
        clonedFilters.push(filter);
      }

      this.filters.value = clonedFilters;
    } else {
      this.filters.value = [filter];
    }
  }

  removeFilter(id: string | number) {
    this.filters.value = this.filters.value.filter((filter) => filter.scrollerId !== id);
  }

  removeAllFilters() {
    this.filters.value = [];
  }

  /**
   * Sets the field filters.
   *
   * Removes any previously configured filters, effectively performing a remove and add filter(s).
   *
   * @param filters the filters to set
   */
  setFilters(filters: ContinuousScrollerFilter[]) {
    this.filters.value = filters;
  }
}
